import { render } from "./live-class-participants.vue?vue&type=template&id=0e5ac2ba"
import script from "./live-class-participants.vue?vue&type=script&lang=js"
export * from "./live-class-participants.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__